.screen {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  animation: evx-fadeUp 0.4s ease both;
}
.warning {
  margin: 0;
  font-family: var(--font-heading);
  font-weight: 800;
  font-size: 32px;
  line-height: 1.55;
  letter-spacing: normal;
  color: var(--color-warning);
  animation: evx-blink 1s infinite;
}
.instruction {
  font-size: 14px;
  color: var(--color-neutral-700);
  font-weight: 600;
}
.ring {
  margin: 8px 0;
}
.seconds {
  font-family: var(--font-heading);
  font-weight: 800;
  font-size: 140px;
  line-height: 1;
  font-variant-numeric: tabular-nums;
  color: var(--color-text);
}
.unit {
  font-size: 12px;
  color: var(--color-neutral-600);
  font-weight: 700;
}
